export default "__VITE_ASSET__r7w5Sp25__"